/* eslint-disable react/jsx-props-no-spreading */
import React from "react";
import PropTypes from "prop-types";
import ReactSelect from "react-select";
import OrgDepositAccountCustomOption from "./OrgDepositAccountCustomOption";

const OrganizationDepositAccountSelect = props => {
	const {
		id,
		name,
		orgDepositAccounts,
		orgFeeTypeId,
		isLoading,
		onEdit,
		onChange,
		selectedValue,
	} = props;

	const customOptions = orgDepositAccounts.map(account => ({
		...account,
		onEdit,
		editable: account.value !== -1 && account.value !== 0,
		renderOption: optionProps => (
			<OrgDepositAccountCustomOption
				{...optionProps}
				data={account}
				onEdit={onEdit}
				editable={account.value !== -1 && account.value !== 0}
			/>
		),
	}));

	return (
		<ReactSelect
			id={id}
			name={name}
			options={customOptions}
			value={customOptions.find(option => option.value === selectedValue)}
			onChange={e => onChange(e, orgFeeTypeId)}
			isLoading={isLoading}
			isDisabled={isLoading}
			components={{ Option: OrgDepositAccountCustomOption }}
		/>
	);
};

OrganizationDepositAccountSelect.propTypes = {
	id: PropTypes.string,
	name: PropTypes.string,
	orgDepositAccounts: PropTypes.array,
	orgFeeTypeId: PropTypes.any.isRequired,
	selectedValue: PropTypes.any,
	isLoading: PropTypes.bool,
	onEdit: PropTypes.func.isRequired,
	onChange: PropTypes.func.isRequired,
};

OrganizationDepositAccountSelect.defaultProps = {
	id: undefined,
	name: "",
	orgDepositAccounts: [],
	isLoading: false,
	selectedValue: null,
};

export default OrganizationDepositAccountSelect;
